import { Stack } from '@mui/material';
import { ReactNode } from 'react';

interface RegistrationFooterProps {
  /** Left-side control (typically Back). Omit for primary-only steps. */
  backButton?: ReactNode;
  /** Right-side primary action(s). */
  children: ReactNode;
}

/**
 * Shared wizard footer: Back on the left, primary action(s) on the right.
 * Buttons stay content-width for consistency across steps.
 */
export function RegistrationFooter({ backButton, children }: RegistrationFooterProps) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
      {backButton ?? <span />}
      {children}
    </Stack>
  );
}
